<template>
  <span class="icon">
    <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
      <g clip-path="url(#clip0_13423_57424)">
        <path
          d="M20.0003 25.3334L10.667 16.0001L20.0003 6.66675"
          stroke="#333333"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_13423_57424">
          <rect width="32" height="32" fill="white" />
        </clipPath>
      </defs>
    </svg>
  </span>
</template>
